// extracted by mini-css-extract-plugin
export var collapsedSummary = "_k7-0";